// extracted by mini-css-extract-plugin
module.exports = {"rate":"rate_plan_rate__2esnW","flexibleContainer":"rate_plan_flexibleContainer__3G313"};